// src/theme/theme.ts
import { createTheme } from '@mui/material/styles';

// Add this type declaration before the darkTheme
declare module '@mui/material/styles' {
    interface Palette {
      customColor?: string;
      stab: string;
      stabHighContrast: string;
      button: {
        yellow: {background: string, text: string};
        red: {background: string, text: string};
      }
    }
    interface PaletteOptions {
      customColor?: string;
      stab: string;
      stabHighContrast: string;
      button: {
        yellow: {background: string, text: string};
        red: {background: string, text: string};
      }
    }
  }
  
  export const theme = createTheme({
    palette: {
      mode: "dark",
      background: {
        default: "#121212",
        paper: "#1E1E1E",
      },
      text: {
        primary: "#FFFFFF",
        secondary: "rgba(255, 255, 255, 0.7)",
      },
      stab: "rgba(123, 45, 58, 0.9)",
      stabHighContrast: "rgb(199, 158, 165)",
      button: {
        yellow: {background: "rgba(180, 158, 48, .8)", text: "rgba(255, 255, 255, 1)"},
        red: {background: "rgba(255, 0, 0, 0.8)", text: "rgba(255, 255, 255, 1)"},
      }
    },
    typography: {
      h1: {
        fontFamily: "'Merriweather', serif",
        letterSpacing: "0.03em",
        fontWeight: 700,
      },
    },
  });